'use client';

import { AuthForm } from '@/components/auth-form';
import { SubmitButton } from '@/components/submit-button';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "sonner";
import { useRouter } from "next/navigation";
import { setUserData } from "@/store/mainSlice";
import { useDispatch } from "react-redux";
import axios from 'axios';
import { useGoogleLogin } from "@react-oauth/google";
import { size } from 'zod/v4';



export default function Page() {
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [showLoadingWithGoogle, setShowLoadingWithGoogle] = useState(false)
  const router = useRouter()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");
    console.log("Checking authToken and userId:", { token, userId });
    if (!token || !userId) {
      setLoading(false);
    } else {
      // setLoading(false);
      const redirectPath = localStorage.getItem("postLoginRedirect");
console.log(redirectPath, "---redirectPathredirectPathredirectPath")
if (redirectPath) {
  localStorage.removeItem("postLoginRedirect");
  router.replace(redirectPath);
} else {
  router.replace("/explore-agents");
}
      // router.replace("/");
    }
  }, [router]);



  useEffect(() => {
    // console.log("Unregistering service workers-2");
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
    }
  }, []);



  const responseGoogle = async (response) => {
    if (response && response.access_token) {
      setShowLoadingWithGoogle(true)
      const AUTH_URL = process.env.NEXT_PUBLIC_APP_GOOGLE_AUTH;
      try {
        const res = await axios.post(AUTH_URL, { access_token: response.access_token }, {
          headers: {
            "x-auth-token": process.env.NEXT_PUBLIC_APP_SEND_HEADERS,
          },
        });

        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem("userId", res.data.data._id);

        dispatch(setUserData(res.data.data))

        toast.success("Login Successful!", {
          style: { color: "green" }, // only text color
          position: "top-center",
          iconTheme: { primary: "green", secondary: "#fff" },
        });

        const filteredUser = {
          id: res.data.data._id,
          token: res.data.token,
          name: res.data.data?.name,
          email: res.data.data?.email,
        };
        try {
          await axios.post(
            `${process.env.NEXT_PUBLIC_APP_SITE_WEBSITE_URL}api/users/set-cookie`,
            { user: filteredUser },
            {
              headers: {
                "Content-Type": "application/json",
                "x-auth-token": "",
              },
              withCredentials: true,
            }
          );
        } catch (cookieErr) {
          console.warn("Cookie set failed:", cookieErr);
        }

        // router.push("/");
        const redirectPath = localStorage.getItem("postLoginRedirect");

        if (redirectPath) {
          localStorage.removeItem("postLoginRedirect");
          router.replace(redirectPath);
        } else {
          router.replace("/explore-agents");
        }

      } catch (error) {
        console.error("Error during Google login:", error);
        toast.error(error?.response?.data?.message || "An error occurred while signing in.", {
          style: { color: "red" },
          position: "top-center",
          iconTheme: { primary: "red", secondary: "#fff" }
        });
      } finally {
        setShowLoadingWithGoogle(false)
      }

    } else {
      toast.error("Google login failed. Please try again.", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
    }
  }

  // hook to trigger Google login
  const login = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: (err) => console.error(err),
  });


  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="flex h-dvh w-screen items-center pt-12 md:pt-0 md:items-center justify-center bg-background px-[15px] sm:px-0">
      <div className="w-full max-w-md overflow-hidden rounded-2xl flex flex-col gap-8 border border-[#d5d5d5] dark:border-[#636363] p-[20px] sm:p-[30px] w-[calc(100%-50px)]">
        <div className="flex flex-col items-center justify-center gap-2 text-center sm:px-0 px-0">
          {/* Logo for light theme */}
          <img
            src="/images/colored-logo.png"
            alt="Varnz.AI Logo"
            className="w-32 h-auto object-contain mb-3 dark:hidden"
          />
          {/* Logo for dark theme */}
          <img
            src="/images/varnzLabs.png"
            alt="Varnz.AI Logo (Dark)"
            className="w-32 h-auto object-contain mb-3 hidden dark:block"
          />
          <h3 className="text-xl font-semibold dark:text-zinc-50">Sign in</h3>
          <p className="text-sm text-gray-500 dark:text-zinc-400">
            Use your email and password to Sign in
          </p>
        </div>
        <AuthForm setIsSuccessful={setIsSuccessful}>
          <SubmitButton isSuccessful={isSuccessful}>Sign in</SubmitButton>
          <p className="text-center text-sm text-gray-600 dark:text-zinc-400 mt-0">
            {"Don't have an account? "}
            <Link
              href="/register"
              className="font-semibold text-gray-800 hover:underline dark:text-zinc-200"
            >
              Sign up
            </Link>
            {/* {" · "} */}
            <Link
              href="/forgot"
              className="block font-semibold text-gray-800 hover:underline dark:text-zinc-200 mt-2"
            >
              Forgot Password?
            </Link>
          </p>
          <div className="flex items-center my-2">
            <div className="flex-grow border-t border-gray-300 dark:border-gray-700" />
            <span className="mx-3 text-sm text-gray-500 dark:text-gray-400">OR</span>
            <div className="flex-grow border-t border-gray-300 dark:border-gray-700" />
          </div>
          <div className="flex justify-center w-full">
            <div className="w-full max-w-sm">
              <button
                type='button'
                onClick={() => login()} // trigger Google login
                disabled={showLoadingWithGoogle}
                className="w-full flex items-center justify-center gap-2 bg-white text-gray-800 border border-gray-300 py-2 px-4 rounded-md hover:bg-gray-100 transition cursor-pointer"
              >
                {/* Google Icon */}
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 533.5 544.3"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M533.5 278.4c0-17.4-1.5-34-4.3-50.2H272v95.1h147.5c-6.4 34.5-25.4 63.8-54.3 83.4l88 68.3c51.3-47.3 80.3-117 80.3-196.6z"
                    fill="#4285f4"
                  />
                  <path
                    d="M272 544.3c72.6 0 133.5-24 178-65.1l-88-68.3c-24.4 16.4-55.6 26-90 26-69 0-127.4-46.6-148.3-109.3l-91.7 71c43.3 85.1 132.2 145.7 239.9 145.7z"
                    fill="#34a853"
                  />
                  <path
                    d="M123.7 327.6c-10.6-31.9-10.6-66.5 0-98.4l-91.7-71c-40.1 79.9-40.1 171.8 0 251.7l91.7-71z"
                    fill="#fbbc04"
                  />
                  <path
                    d="M272 107.7c37.3-.6 73.3 13.3 100.7 38.9l75.1-75.1C404.7 24.2 341.6-1.6 272 0 164.3 0 75.4 60.6 32 145.7l91.7 71c20.9-62.7 79.3-109.3 148.3-109.3z"
                    fill="#ea4335"
                  />
                </svg>

                {showLoadingWithGoogle ? "Please wait..." : "Continue with Google"}
              </button>
            </div>
          </div>
        </AuthForm>
      </div>
    </div>
  );
}
